import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import styled from 'styled-components';
import { MdPersonAddAlt1 } from 'react-icons/md';

import { pages } from '@/settings/pages';

type Props = {
  children?: never;
  isManager: boolean;
};

export const InvitationLink: React.FC<Props> = (props) => {
  const { isManager } = props;
  const { t } = useTranslation();

  if (!isManager) {
    return null;
  }

  return (
    <Styled>
      <Link
        to={pages.membership.invite}
        data-test="invite-link"
        className="with-icon"
      >
        <MdPersonAddAlt1 className="icon" />
        {t('ui.action.inviteManager')}
      </Link>
    </Styled>
  );
};

const Styled = styled.div`
  margin: -3.3em 0 2em 0;
  display: flex;
  justify-content: flex-end;

  .with-icon {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .icon {
    width: 18px;
    height: 100%;
  }
`;
